import useTranslation from 'next-translate/useTranslation';
import { ReloadIcon } from '../../icons';
import IconButton from '../IconButton';
import styles from './styles.module.scss';

export interface INotesButtonReloadItemProps {
  onClick: () => void;
}

const NotesButtonReloadItem = ({ onClick }: INotesButtonReloadItemProps) => {
  const { t } = useTranslation('common');
  return (
    <IconButton
      className={styles.container}
      icon={
        <>
          <span className={styles.iconContainer}>
            <ReloadIcon width={21} height={21} />
          </span>
          <p>{t('notes.warning_before_reloading')}</p>
        </>
      }
      onClick={onClick}
    />
  );
};

export default NotesButtonReloadItem;
